import { Component, inject, OnDestroy } from '@angular/core';
import { ImportAbstractDirective, ImportFileTypes } from '../import.abstract.directive';
import { AuditDatabaseResource, DatabaseImportResponse } from '../../resources/import.abstract.resource';
import { BreadcrumbsService } from '../../../shared/breadcrumbs/breadcrumbs.service';
import { Observable, throwError } from 'rxjs';

@Component({
  selector: 'ziro-admin-import-audit',
  templateUrl: '../import.abstract.component.html',
  styleUrls: ['../../admin-page.scss', '../import.abstract.component.scss'],
  standalone: false,
})
export class ImportAuditsComponent extends ImportAbstractDirective implements OnDestroy {
  private auditDatabaseResource = inject(AuditDatabaseResource);
  private breadcrumbsService = inject(BreadcrumbsService);

  warningText = 'tkey;pages.admin.audit.import.warning.text';
  warningTextPreamble = 'tkey;pages.admin.audit.import.warning.preamble.text';

  constructor() {
    super();
    this.breadcrumbsService.updateBreadcrumbs([{ label: 'tkey;pages.admin.audit.import.header' }]);
    this.importFileType = ImportFileTypes.AUDIT;
  }

  ngOnDestroy(): void {
    this.breadcrumbsService.clearBreadcrumbs();
  }

  requestImport = (): Observable<DatabaseImportResponse> => {
    const request = this.getImportRequest();

    if (request) {
      return this.auditDatabaseResource.post(request);
    } else {
      return throwError(null);
    }
  };
}
